module.exports = __webpack_public_path__ + "static/img/use03.8d3dc4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/mo/use03.png
// module id = 706A
// module chunks = 10